<template lang="html">

  <div class="row">
    <div class="col-3">
      <div class="profileInfo">
        <div class="basic-info-section">
          <div class="section-header">
            <i class="fas fa-user"></i>
            <h3 class="section-title">My Mission</h3>
          </div>
          <ul class="mission-list">
            <li class="career">
              <i class="fa-li fa fa-briefcase"></i><span>Contributes toward the future of digital technology</span>
            </li>
            <li class="fitness">
              <i class="fa-li fa fa-dumbbell"></i> <span>Prioritizes my fitness goals</span>
            </li>
            <li class="diet">
              <i class="fa-li fa fa-apple-alt"></i> <span>Makes healthy diet choices part of my lifestyle</span>
            </li>
            <li class="finance">
              <i class="fa-li fa fa-dollar-sign"></i> <span>Saves money and is frugal</span>
            </li>
            <li class="fun">
              <i class="fa-li fa fa-hiking"></i> <span>Spends time outdoors and enjoying time with friends</span>
            </li>
            <li class="health">
              <i class="fa-li fa fa-heartbeat"></i> <span>Practices healthy habits and avoids bad ones</span>
            </li>
            <li class="intellect">
              <i class="fa-li fa fa-brain"></i> <span>Stays intellectually curious and always learning about new topics and skills</span>
            </li>
            <li class="relationships">
              <i class="fa-li fa fa-user-friends"></i> <span>Maintains positve, long-lasting relationships</span>
            </li>
            <li class="spiritual">
              <i class="fa-li fa fa-peace"></i> <span>Seeks to find a deeper awareness of connection to the world around me</span>
            </li>
            <li class="travel">
              <i class="fa-li fa fa-plane"></i> <span>Explores new places and discovers new experiences</span>
            </li>
            <li class="community">
              <i class="fa-li fa fa-users"></i> <span>Actively participates in volunteer and government policy</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-5">

      <PostBox />
      <Post />

    </div>
    <div class="col-4">
      <!-- <p class="lead">{{ this.dateRange }}</p> -->
      <div id="profilePage" class="cardWrapper hidden">
        <div class="card" v-for="goal in goals" :key="goal.id">
          <div class="card-body">
          <div class="progress">
            <div class="progress-bar" role="progressbar" :style="{width: frequencyMet(goal.frequencyGoal, goal.frequencyMet) + '%'}" :aria-valuenow="{width: frequencyMet(goal.frequencyGoal, goal.frequencyMet) + '%'}" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
            <div v-if="isMe" class="dropdown">
              <button class="float-right btn-goal-options btn btn-sm" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="false" aria-expanded="false">
                <i class="fa fa-ellipsis-v"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <router-link class="dropdown-item" :to="{ name: 'EditGoal', params: { id: goal.id} }">Edit</router-link>
                <a class="dropdown-item" href="#" @click.prevent="deleteGoal(goal.id)">Delete</a>
              </div>
            </div>
            <h3><router-link :to="{ name: 'SingleGoal', params: { id: goal.id } }">{{ goal.title }}</router-link></h3>
            <!-- <p>{{ goal.description }}</p> -->
            <div v-if="!isMe" class="goalProgressBar">
              <span :class="goal.thisWeek.day1">MON</span>
              <span :class="goal.thisWeek.day2">TUES</span>
              <span :class="goal.thisWeek.day3">WED</span>
              <span :class="goal.thisWeek.day4">THURS</span>
              <span :class="goal.thisWeek.day5">FRI</span>
              <span :class="goal.thisWeek.day6">SAT</span>
              <span :class="goal.thisWeek.day7">SUN</span>
            </div>
            <div v-if="isMe" class="btn-group btn-group-justified" role="group">
              <button :disabled="isDisabled(0)" @click.prevent="updateDay(goal.id, 'day1', goal.thisWeek.day1)" type="button" class="btn btn-sm" :class="dayStatus(goal.thisWeek.day1)">MON</button>
              <button :disabled="isDisabled(1)" @click.prevent="updateDay(goal.id, 'day2', goal.thisWeek.day2)" type="button" class="btn btn-sm" :class="dayStatus(goal.thisWeek.day2)">TUES</button>
              <button :disabled="isDisabled(2)" @click.prevent="updateDay(goal.id, 'day3', goal.thisWeek.day3)" type="button" class="btn btn-sm" :class="dayStatus(goal.thisWeek.day3)">WED</button>
              <button :disabled="isDisabled(3)" @click.prevent="updateDay(goal.id, 'day4', goal.thisWeek.day4)" type="button" class="btn btn-sm" :class="dayStatus(goal.thisWeek.day4)">THURS</button>
              <button :disabled="isDisabled(4)" @click.prevent="updateDay(goal.id, 'day5', goal.thisWeek.day5)" type="button" class="btn btn-sm" :class="dayStatus(goal.thisWeek.day5)">FRI</button>
              <button :disabled="isDisabled(5)" @click.prevent="updateDay(goal.id, 'day6', goal.thisWeek.day6)" type="button" class="btn btn-sm" :class="dayStatus(goal.thisWeek.day6)">SAT</button>
              <button :disabled="isDisabled(6)" @click.prevent="updateDay(goal.id, 'day7', goal.thisWeek.day7)" type="button" class="btn btn-sm" :class="dayStatus(goal.thisWeek.day7)">SUN</button>
            </div>
          </div>
          <div v-if="goal.updating" class="card-footer">
            <button @click.prevent="saveGoal(goal.id)" type="button" class="btn btn-primary" name="button">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import firebase from 'firebase'
import moment from 'moment'
import db from '@/store/firebaseinit'
import Navbar from '@/components/utility/Navbar'
import PostBox from '@/components/utility/PostBox'
import Post from '@/components/utility/Post'

export default {
  name: 'ProfileMain',
  components: {
    Navbar,
    PostBox,
    Post,
  },
  watch: {
    '$route.params.username': function () {
      this.getInfo()
    }
  },
  data() {
    return {
      goals: [],
      thisWeeksDates: [],
      dateRange: null,
      user: 'No one',
      days: null,
      weeks: null,
      isMe: null,
      uid: null,
      mainComment: null,
    }
  },
  created() {

    this.getInfo()
    // Calculate the week
    var mondayCalc = moment().format('E') - 1
    var weekStart = moment().add(-mondayCalc, 'days')
    var i
    for(i = 0; i < 7; i++) {
      this.thisWeeksDates[i] = weekStart.format('YYYY-MM-DD')
      weekStart = weekStart.add(+1, 'days')
    }

    // Show This Week's Date Range
    var mondayCalc = moment().format('E') - 1
    var weekStart = moment().add(-mondayCalc, 'days')
    var weekEnd = moment().add(-mondayCalc + 6, 'days')

    // Check if week end month is different from week start month, if so display it
    if(weekStart.format('MMMM') == weekEnd.format('MMMM')) {
      this.dateRange = weekStart.format('MMMM DD - ') + weekEnd.format('DD')
    } else {
      this.dateRange = weekStart.format('MMMM DD - ') + weekEnd.format('MMMM DD')
    }
  },
  methods: {
    getInfo() {
      this.goals = []
      db.collection('users').where('username','==',this.$route.params.username).get()
      .then(result => {
        if(!result.empty) {
          result.forEach(doc => {
            this.user = doc.data()
            this.uid = doc.id
            db.collection('goals').where('userId','==',doc.id).get()
            .then(snapshot => {
              snapshot.forEach(doc => {
                let goal = doc.data()
                goal.id = doc.id
                goal.updating = false
                goal.tempFrequencyMet = goal.frequencyMet
                this.goals.push(goal)
              })
              this.showGoals()
              if(firebase.auth().currentUser.uid == this.uid) {
                this.isMe = true
              } else {
                this.isMe = false
              }
              $('#profilePage').removeClass('d-none')
            }).catch(error => {
              console.log(error.message)
            })

          })
        } else {
          this.$router.push({ name: 'Error404' })
        }
      }).catch(error => {
        console.log('Could not query the database')
      })
    },
    isDisabled(weekday) {
      var start = this.thisWeeksDates[0]
      var today = moment().format('YYYY-MM-DD')
      var theDay = this.thisWeeksDates[weekday]
      var isBetween = moment(theDay).isBetween(start, today, null, [])
      if(!isBetween) {
        return 'disabled'
      }
    },
    frequencyMet(goal, met) {
      var percentage = (met / goal) * 100
      if (percentage > 100) { percentage = 100 }
      return percentage
    },
    dayStatus(status) {
      if (status == 'success') {
        status = "btn-primary"
      } else if (status == 'failed') {
        status = "btn-danger"
      } else {
        status = "btn-secondary"
      }
      return status
    },
    deleteGoal(id) {
      db.collection('goals').doc(id).delete()
      .then(() => {
        db.collection('goalHistory').doc(id).delete()
        .then(() => {
          this.goals = this.goals.filter(goal => {
            return goal.id != id
          })
        })
      })
    },
    showGoals() {
      var mondayCalc = moment().format('E') - 1
      var weekStart = moment().add(-mondayCalc, 'days').format('YYYY-MM-DD')

      db.collection('goals').where('userId','==',this.uid).get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let goal = doc.data()
          goal.id = doc.id
          if(goal.thisWeek.weekStart != weekStart) {
            db.collection('goals').doc(goal.id).update({
              frequencyMet: 0,
              thisWeek: {
                day1: '',
                day2: '',
                day3: '',
                day4: '',
                day5: '',
                day6: '',
                day7: '',
                weekStart: weekStart,
                completed: false
              }
            }).then(() => {
              this.goals.filter(function(v,i) {
                if(v['id'] === goal.id) {
                  v.thisWeek.day1 = ''
                  v.thisWeek.day2 = ''
                  v.thisWeek.day3 = ''
                  v.thisWeek.day4 = ''
                  v.thisWeek.day5 = ''
                  v.thisWeek.day6 = ''
                  v.thisWeek.day7 = ''
                  v.thisWeek.weekStart = weekStart
                  v.frequencyMet = 0
                  v.tempFrequencyMet = 0
                  $('.cardWrapper').removeClass('hidden')
                }
              })
            }).catch(error => {
              console.log(error)
            })
          } else {
            $('.cardWrapper').removeClass('hidden')
          }
        })
      })
    },
    saveGoal(goalId) {
      // Takes local data and saves to database

      this.goals.filter(function(v,i) {
        if(v['id'] == goalId) {
          db.collection('goals').doc(goalId).update({
            // update goals document using local data
            thisWeek: {
              day1: v['thisWeek']['day1'],
              day2: v['thisWeek']['day2'],
              day3: v['thisWeek']['day3'],
              day4: v['thisWeek']['day4'],
              day5: v['thisWeek']['day5'],
              day6: v['thisWeek']['day6'],
              day7: v['thisWeek']['day7'],
              weekStart: v['thisWeek']['weekStart'],
              completed: v['thisWeek']['completed']
            },
            frequencyMet: v['tempFrequencyMet']
          }).then(() => {

            db.collection('goalHistory').doc(goalId).get()
            .then(snapshot => {
              this.days = snapshot.data().days
              this.days[this.thisWeeksDates[0]] = v['thisWeek']['day1']
              this.days[this.thisWeeksDates[1]] = v['thisWeek']['day2']
              this.days[this.thisWeeksDates[2]] = v['thisWeek']['day3']
              this.days[this.thisWeeksDates[3]] = v['thisWeek']['day4']
              this.days[this.thisWeeksDates[4]] = v['thisWeek']['day5']
              this.days[this.thisWeeksDates[5]] = v['thisWeek']['day6']
              this.days[this.thisWeeksDates[6]] = v['thisWeek']['day7']
              this.weeks = snapshot.data().weeks
              this.weeks[this.thisWeeksDates[0]] = {'frequencyGoal': v['frequencyGoal'], 'frequencyMet': v['tempFrequencyMet']}
              db.collection('goalHistory').doc(goalId).update({
                days: this.days,
                weeks: this.weeks
              }).then(() => {
                // Hide save bar
                v['updating'] = false
                // Updates 'frequency met' on particular goal to update the progress bar (locally)
                v['frequencyMet'] = v['tempFrequencyMet']
                this.checkCompletion(goalId)
              }).catch(error => {
                console.log('Could not update goal history in database' + error)
              })
            })
          }).catch(error => {
            console.log("Could not update goals in database" + error)
          })
        }
      }.bind(this))
    },
    checkCompletion(goalId) {
      this.goals.filter(function(v,i) {
        var completionRate = (v['frequencyMet'] / v['frequencyGoal'])*100
        if(v['id'] === goalId && v['thisWeek']['completed'] != true) {

          if(completionRate < 100) {
            // Still working on the goal!
          } else {
            v['thisWeek']['completed'] = true
            db.collection('goals').doc(goalId).update({
              thisWeek: {
                day1: v['thisWeek']['day1'],
                day2: v['thisWeek']['day2'],
                day3: v['thisWeek']['day3'],
                day4: v['thisWeek']['day4'],
                day5: v['thisWeek']['day5'],
                day6: v['thisWeek']['day6'],
                day7: v['thisWeek']['day7'],
                weekStart: v['thisWeek']['weekStart'],
                completed: true
              },
            }).then(() => {
              alert('Congrats! You completed your goal this week!')
            }).catch(error => {
              console.log("There was an issue updating the completion of your goal" + error)
            })
          }
        } else if (v['id'] === goalId && v['thisWeek']['completed'] == true && completionRate < 100) {
          v['thisWeek']['completed'] = false
          db.collection('goals').doc(goalId).update({
            thisWeek: {
              day1: v['thisWeek']['day1'],
              day2: v['thisWeek']['day2'],
              day3: v['thisWeek']['day3'],
              day4: v['thisWeek']['day4'],
              day5: v['thisWeek']['day5'],
              day6: v['thisWeek']['day6'],
              day7: v['thisWeek']['day7'],
              weekStart: v['thisWeek']['weekStart'],
              completed: false
            },
          }).then(() => {
            // it's all updated!
          }).catch(error => {
            console.log("There was an issue updating the completion of your goal" + error)
          })
        }
      })
    },
    updateDay(goalId, goalDay, goalStatus) {
      // Find the goal locally
      this.goals.filter(function(v,i) {
        var updatedStatus
        if(v['id'] === goalId) {

          // Show the save button
          v['updating'] = true

          if(goalStatus == '') {
            updatedStatus = 'success'
            v['tempFrequencyMet'] = v['tempFrequencyMet'] + 1
          } else if (goalStatus == 'success') {
            updatedStatus = 'failed'
            v['tempFrequencyMet'] = v['tempFrequencyMet'] - 1
          } else {
            updatedStatus = ''
          }
          v['thisWeek'][goalDay] = updatedStatus
        }
      }.bind(this))
    },
  },
}
</script>

<style scoped>
.header {
  margin-bottom: 30px;
  border: 1px solid #c9c9c9;
  border-top: none;
}
.header-top {
  background-image: none !important;
  background-color: grey;
  height: 170px;
}
.header-top.has-cover-photo {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 350px;
}
.header-top .name {
  position: absolute;
  bottom: 87px;
  left: 230px;
  font-size: 23px;
  font-weight: bold;
  color: #fff;
}
.header-top .edit-buttons {
  list-style-type: none;
  position: absolute;
  bottom: 87px;
  right: 33px;
  font-size: 23px;
  font-weight: bold;
}
.header-top .edit-buttons li {
  display: inline;
}
.header-menu {
  list-style-type: none;
  margin: 0;
  padding: 0;
  height: 54px;
}
.header-menu li {
  display: inline;
  padding: 0;
  margin: 0 -2px;
}
.header-menu li a {
  padding: 16px 18px;
  border-right: 1px dotted #c9c9c9;
}
.header-menu li a:hover {
  text-decoration: none;
  color: #0056b3;
}
.header-menu li button:hover {
  cursor: pointer;
  color: #0056b3;
}
.header-menu li button {
  background: none;
  border: none;
  outline: none !important;
  color: #007bff;
}
.header-menu li button {
  background: none;
  border: none;
  outline: none !important;
}
.header-menu .dropdown-menu .dropdown-item {
  padding: 4px 15px;
  font-size: 14px;
}
.header-menu .profileImage {
  margin: -130px 10px 20px 20px;
  border: 4px solid #fff;
  -webkit-box-shadow: 0px 0px 28px -7px rgba(0,0,0,0.17);
  -moz-box-shadow: 0px 0px 28px -7px rgba(0,0,0,0.17);
  box-shadow: 0px 0px 28px -7px rgba(0,0,0,0.17);
}
.basic-info-section {
  background: #efefef;
  padding: 20px;
  border: 1px dotted #c9c9c9;
  border-radius: 5px;
}
.basic-info-section .section-title {
  font-size: 18px;
  margin: 0;
  padding: 0 0 15px 0;
}
.basic-info-section .section-header {
  margin-top: -30px;
  text-align: center;
}
.basic-info-section i.fa-user {
  color: #fff;
  background:#007bff;
  padding: 8px 9px;
  font-size: 13px;
  border-radius: 50%;
  margin: -1px 0 10px 0;
  -webkit-box-shadow: 0px 0px 28px -7px rgba(0,0,0,0.17);
  -moz-box-shadow: 0px 0px 28px -7px rgba(0,0,0,0.17);
  box-shadow: 0px 0px 28px -7px rgba(0,0,0,0.17);
}
.basic-info-section .subtext {
  font-size: 13px;
  text-align: center;
}
.mission-list {
  font-size: 13px;
  padding-left: 18px;
  list-style-type: none;
  margin-bottom: 0;
}
.mission-list li {
  font-style: italic;
  margin-bottom: 10px;
}
.mission-list li:last-child {
  margin-bottom: 0;
}
.mission-list li span {
  position: relative;
  left: 5px;
}
.mission-list li i {
  left: 30px;
  color: #6c757d;
}
.card {
  background: #efefef;
}
.card h3 {
  font-size: 17px;
  padding: 0;
  margin: 0 0 10px 0;
}
.card-body {
  padding: 15px;
}
.card-body p {
  font-size: 12px;
}
.progress {
  margin-bottom: 10px;
  height: 5px;
  background: #bbb;
}
.btn-group-justified {
  display: flex;
}
.btn-group-justified .btn {
  flex-grow: 1;
  padding: 3px 0;
  font-size: 13px;
}
.card {
  margin-bottom: 15px;
}
.hidden {
  display: none;
}
.goalProgressBar {
  display: flex;
}
.goalProgressBar span {
  flex-grow: 1;
  text-align: center;
  line-height: 1.5;
  border-radius: 0;
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
  padding: 3px 0;
  font-size: 13px;
}
.goalProgressBar span.success {
  background-color: #007bff;
  border-color: #007bff;
}
.goalProgressBar span.failed {
  background-color: #dc3545;
  border-color: #dc3545;
}
.goalProgressBar span:first-child {
    border-radius: .2rem 0 0 .2em !important;
}
.goalProgressBar span:last-child {
    border-radius: 0 .2rem .2em 0 !important;
}
.btn-goal-options {
  font-size: 10px;
padding: 2px 4px;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/ProfileMain.vue